import { Typography } from '@mui/material';
import { LoadingScreen } from '@truvhq/ui';

import { TenantCompanies } from 'features/tenancy/ui/TenantCompanies';
import { useGetCompanySettings, useGetTenantCompanies } from 'hooks/company';
import { useAuth } from 'shared/lib/auth/useAuth';
import { useTenancyContext } from 'shared/lib/tenancy/useTenancyContext';
import { AuthHeroMessage } from 'shared/ui/AuthHeroMessage';

export type UnapprovedCompanyMemberProps = {
  declined: boolean;
};

export const UnapprovedCompanyMember = ({ declined }: UnapprovedCompanyMemberProps) => {
  const { user } = useAuth();
  const { data: company, isFetching: isCompanyFetching } = useGetCompanySettings();
  const { data: tenantCompanies } = useGetTenantCompanies();
  const { setTenantCompanyId } = useTenancyContext();

  const hasTenantCompanies = tenantCompanies && tenantCompanies.length >= 1;
  const currentTenantCompanyId = user?.company?.id;
  const ownerEmail = user?.profile?.company?.owner_email;

  if (isCompanyFetching) {
    return <LoadingScreen />;
  }

  const companyName = user?.company?.name || company?.name;

  const title = declined ? 'Your account has been declined' : 'Account pending approval';
  const subtitle = declined ? (
    `Your request to join ${companyName} was not approved. If you have questions, contact an owner or administrator at ${companyName}.`
  ) : (
    <>
      An email has been sent to the company owner{ownerEmail && ` (${ownerEmail})`}. Once approved, you’ll receive an
      email and be able to login to Truv.
    </>
  );

  return (
    <AuthHeroMessage withSupport title={title} subtitle={subtitle}>
      {hasTenantCompanies && (
        <div className="flex w-full max-w-[360px] flex-col gap-2 pt-2">
          <Typography className="text-[15px] text-white/70">You can switch to your other companies:</Typography>
          <TenantCompanies
            tenantCompanies={tenantCompanies}
            onSelectCompany={setTenantCompanyId}
            selectedCompanyId={currentTenantCompanyId}
            variant="light"
            placeholder="Select company"
            popoverDirection="bottom"
            autoSelectFirst={false}
          />
        </div>
      )}
    </AuthHeroMessage>
  );
};
